import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { ReservationsServices } from '../../services';
import { ReservationConfigHorary } from '../reservation-config-horary/reservation-config-horary';
import { AnalyticsServices } from '../../../services/analyticsServices';


@Component({
    selector: 'page-reservation-config-camps',
    templateUrl: 'reservation-config-camps.html',
})
export class ReservationConfigCamps {
    firestore: any;
    fields: any;
    fields_default: any;
    fields_default_inputs: any;
    form_stripes: any = [
        {
            start: '05:00',
            end: '11:59',
            name: this.translate.instant('general-desayuno')
        },
        {
            start: '12:00',
            end: '17:59',
            name: this.translate.instant('general-almuerzo')
        },
        {
            start: '18:00',
            end: '04:59',
            name: this.translate.instant('general-cena')
        }
    ];

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public reservationsServices: ReservationsServices,
        public afs: AngularFirestore,
        public translate: TranslateService,
        public analyticsServices: AnalyticsServices) {
        this.firestore = firebase.firestore();
    }

    async ionViewWillEnter() {
        this.fields_default = [
            {
                active: true,
                name: this.translate.instant('general-comensales'),
                options: "",
                order: 0,
                required: true,
                type: "text"
            },
            {
                active: true,
                name: this.translate.instant('general-fecha'),
                options: "",
                order: 1,
                required: true,
                type: "date"
            },
            {
                active: true,
                name: this.translate.instant('general-hora'),
                options: "",
                order: 2,
                required: true,
                type: "time"
            },
            {
                active: true,
                name: this.translate.instant('general-nombre-completo'),
                options: "",
                order: 2,
                required: true,
                type: "text"
            },
            {
                active: true,
                name: this.translate.instant('login-correo-electronico'),
                options: "",
                order: 2,
                required: true,
                type: "email"
            }
        ];
        this.fields_default_inputs = [
            {
                active: true,
                name: this.translate.instant('general-telefono'),
                options: "",
                required: false,
                type: "text",
                input_name: 'phone'
            },
            {
                active: true,
                name: this.translate.instant('general-direccion'),
                options: "",
                required: false,
                type: "text",
                input_name: 'address'
            }
        ];
        this.fields = [
            {
                active: true,
                name: this.translate.instant('general-campo-comentario'),
                options: "",
                required: false,
                type: "text",
                input_name: 'comments'
            }
        ];
    }

    next() {
        this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            form_inputs: this.fields,
            form_inputs_default: this.fields_default_inputs,
            form_stripes: this.form_stripes,
            form_persons_min: 2,
            form_persons_max: 10,
            form_time_interval: 30,
            autoaccept_persons_max_per_stripe: 50,
            form_title: "Haz tu reserva",
            form_subtitle: "Completa el formulario y reserva tu mesa"
        });
        this.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
            plg_reservas_starter: true
        });
        this.globals.restaurant.plg_reservas_starter = true;
        //update hubspot contact
        this.globals.updateERPNextCustomer();
        //send trackingExpReservations
        this.analyticsServices.trackingExpReservations('starter', this.globals.tracking_exp['starter']);
        //next page config
        this.navCtrl.push(ReservationConfigHorary);
    }
}



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-config/reservation-config-camps/reservation-config-camps.ts